import {LcdSubscriptions} from './typedef';

export const LCD_HEADLINES: Record<string, string> = {
    [LcdSubscriptions.NEWS]: 'News',
    [LcdSubscriptions.RESEARCH]: 'Research',
};

export const LCD_EXPLANATIONS: Record<string, string> = {
    [LcdSubscriptions.NEWS]:
        'Sign up to subscribe the user to news articles about the Leveraged Loan and High Yield Bond markets.\n' +
        'The user will get an email as soon as they are published, and the user can expect to see multiple\n' +
        'articles daily for some topic codes.',
    [LcdSubscriptions.RESEARCH]:
        'Sign up to subscribe the user to news articles about the Leveraged Loan and High Yield Bond markets.\n' +
        'The user will get an email as soon as they are published, and the user can expect to see multiple\n' +
        'reports daily for some asset classes.',
};
